var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "40px",
    viewBox: "0 0 26 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.9289,
    x2: 21.071,
    y1: 28.071,
    y2: 11.929
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.9289,
    x2: 21.071,
    y1: 11.929,
    y2: 28.071
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuX);
export default __webpack_public_path__ + "static/media/menu-x.ddb3f9cde0b8a589e0d480d87e36c01d.svg";
export { ForwardRef as ReactComponent };